<template>
  <div v-if="isLoggedIn" id="app">
    <notifications group="admin" position="top center" />
    <div class="admin-layout">
      <div class="main-navbar navbar fixed-top my-0 py-0">
        <a href="/competitive-dashboard">
          <img src="./assets/img/wRatings-2700x860.png" alt="wRatings Admin"  height="43" />
        </a>
        <ul class="main-navbar-menu nav align-self-stretch flex-nowrap">
          <li class="nav-item dropdown">
            <a class="line-height-1 d-flex align-items-center h-100 text-left nav-link dropdown-toggle" data-toggle="dropdown" href="#">
              <img class="personalProfilePhoto logo-image mr-1" :src="logoImage" alt />
              <span class="d-none d-md-inline">
                <small class="d-flex">Welcome,</small>
                {{ fullName }}
              </span>
            </a>
            <ul class="dropdown-menu dropdown-menu-right">
              <li>
                <router-link class="dropdown-item" :to="{ name: 'user-settings', params: { initialUserId: this.currentUser.id, initialUserCode: this.currentUser.userCode } }">
                  <i class="fa fa-lg fa-fw fa-user"></i>
                  Account
                </router-link>
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" href="#" @click="displaySalesGrowthUniversity()">
                  <i class="fa-duotone fa-box-dollar" style="font-size: 20px;color: #2f5eb3"></i>
                  <span class="pl-2">Fast Start</span>
                </a>
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" href="#" @click="handleLogout()">
                  <font-awesome-icon :icon="['fas', 'sign-out-alt']" size="lg" />
                  <span class="pl-2">Log Out</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div :class="[!this.$root.getShowMainMenu() ? 'panel-admin-expanded container-fluid' : 'panel-admin container-fluid']">
        <main-menu ref="mainMenu" :is-admin="isAdmin" :is-executive="isExecutiveUser" :is-power="isPowerUser" :is-basic="isBasicUser" :is-insider="isInsiderUser"></main-menu>
        <bread-crumb />
        <div class="organization-survey-header">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <treeselect
              v-model="treeValue"
              class="no-shadow"
              v-tooltip="{ content: msg, show: autoDisplayGetStartedToolTip }"
              @select="changeClientCodeEvent"
              :multiple="false"
              :show-count="true"
              :default-expand-level="defaultExpandLevel"
              :options="clientOptions"
              :append-to-body="true"
              :required="true"
              :clearable="false"
              :maxHeight="400"
              placeholder="Search..."
            />
          </div>
          <div  class="col-lg-4 col-md-6 col-sm-12">
            <div class="d-flex survey-display">
              <label for="survey_id">{{ surveyLabel }}</label>
              <div v-show="displaySurveyWidget" class="w-100">
                <v-select
                  id="surveyCode"
                  name="surveyCode"
                  :disabled="disableSurveyDropdown"
                  :options="clientObject.surveyCodes"
                  :reduce="survey => survey.surveyCode"
                  label="name"
                  :clearable="false"
                  @input="saveSurveyInUserSettings"
                  required
                  v-model="surveyCode"
                >
                </v-select>
              </div>
              <button v-clipboard="getUrl" v-tooltip="tooltipConfigShow" v-clipboard:success="clipboardSuccessHandler" class="share-button">
                <font-awesome-icon :icon="['fa', 'share-alt']" size="xl" />
              </button>
            </div>
          </div>
        </div>
        <router-view />
        <div id="pagetop" class="fixed right-0 bottom-0" v-show="displayScrollToTopButton" @click="toTop">
          <button type="button" class="btn btn-info btn-to-top"><i class="fa fa-chevron-up"></i></button>
        </div>
      </div>
    </div>
    <sales-growth-university-modal :modal-id="'sales-growth-university'"/>   
    <user-agreement-modal :modal-id="'user-agreement-modal'" :modal-title="'User License Agreement'" @logout="handleLogout()"
/>
</div>
  <div v-else>
    <router-view></router-view>
  </div>
</template>
<script>
import Vue from "vue";
import MainMenu from "./views/menu/MainMenu.vue";
import jQuery from "jquery";
import BreadCrumb from "./components/BreadCrumb.vue";
import SalesGrowthUniversityModal from "./modals/SalesGrowthUniversityModal.vue";
import UserAgreementModal from "./modals/UserAgreementModal.vue";

import GoogleService from "./services/google.service";
import ClientService from "./services/client.service";
import ErrorService from "./services/error.service";
import AdminService from "./services/admin.service";
import SurveyService from "./services/survey.service";
import UserService from "./services/user.service";
import ContentService from "./services/content.service";
import UserSettingsService from "./services/user.settings.service";
import ViewMixins from "./mixins/ViewMixins.vue";
import Treeselect from "@riophae/vue-treeselect";

import VTooltip from "v-tooltip";
Vue.use(VTooltip);

import Clipboard from "v-clipboard";
import VueLogger from "vuejs-logger";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";
Vue.component("treeselect", Treeselect);
import { oktaAuth, oktaAuthLogout } from "./okta";
import $ from "jquery";
const options = {
  isEnabled: true,
  logLevel: typeof process.env.VUE_APP_LOG_LEVEL != "undefined" ? process.env.VUE_APP_LOG_LEVEL : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};

Vue.use(VueLogger, options);
Vue.use(Clipboard);

export default {
  name: "App",
  components: {
    MainMenu,
    BreadCrumb,
    SalesGrowthUniversityModal,
    UserAgreementModal,
    Treeselect
  },
  mixins: [ViewMixins],
  data() {
    return {
      treeValue: null,
      clientId: 0,
      clientCode: "",
      clientObject: {},
      survey: {},
      clientOptions: [],
      message: "",
      dataLoaded: false,
      autoDisplayGetStartedToolTip: true,
      surveyCode: "",
      logoImage: "",
      authenticated: false,
      displayShowMenuIcon: false,
      disableSurveyDropdown: false,
      msg: "Select the level you want to analyze",
      tooltipConfigShow: ContentService.getShareButtonTooltip(),
      scrollTimer: 0,
      scrollYAxis: 0,      
    };
  },
  methods: {
    displaySalesGrowthUniversity(){
      this.autoDisplayGetStartedToolTip=false;
      this.$modal.show('sales-growth-university');
    },
    clipboardSuccessHandler(){
      this.$notify(AdminService.displaySuccessMessage({ text: "Link Copied" },true));
    },
    getUrl(){
      return this.fullUrl;
    },
    handleScroll: function () {
      if (this.scrollTimer) return;
      this.scrollTimer = setTimeout(() => {
        this.scrollYAxis = window.scrollY;
        clearTimeout(this.scrollTimer);
        this.scrollTimer = 0;
      }, 100);
    },
    toTop: function () {
      window.scrollTo({top: 0, behavior: "smooth"});
    },
    toggleMainMenu: function() {
      this.$refs.mainMenu.trackCollapseEvent("Main Menu Toggle - Header");
    },
    toggleHeaderMenu: function() {
      let label = this.$root.getShowHeaderMenu() ? "close" : "open";
      GoogleService.logClickEvent("Header Menu Toggle", label, 0, this);         

      this.$root.toggleHeaderMenu();
    },
    changeSurveyCodeValue: function(value) {
      this.surveyCode = value;
    },
    refreshPage: function() {
      this.$notify(AdminService.displayInfoMessage({ text: "Refreshing page please stand by......" }));
      this.$router.go();
    },
    getAllClientsCallback(data) {
      this.clientOptions = data;
      this.dataLoaded = true;
    },
    async changeClientCodeEvent(selection) {
      GoogleService.logBaseEvent("change", "Change Organization", selection.label, 0, this);
      await this.changeClientCodeValue(selection.id);
      if (isNaN(selection.id)){
        await UserSettingsService.saveUserSetting("client-id", selection.id, 0, this.saveUserSettingCallback, this);
      }
    },
    async saveSurveyInUserSettings(selection) {
      this.logSurveyEvent(selection);
      await UserSettingsService.saveUserSetting("survey-code", selection, 0, this.saveUserSettingCallback, this);
    },
    saveUserSettingCallback: function (response) {
      UserSettingsService.saveAllUserSettings(response.data.data.userSettings);
    },    
    logSurveyEvent(selection) {
      GoogleService.logBaseEvent("change", "Change Survey", selection, 0, this);
    },
    async changeClientCodeValue(value) {
      this.autoDisplayGetStartedToolTip = false;
      VTooltip.enabled = false;
      this.$root.processServerRequest("Retrieving client");
      await ClientService.changeClient(this.baseUrl, value, this.changeClientCallback, this);
    },
    changeClientCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.$notify(AdminService.displaySuccessMessage({ text: response.data.message }));
        this.clientObject = response.data.data;
        this.clientId = this.clientObject.clientId;
        this.clientCode = this.clientObject.clientCode;
        ClientService.saveClient(this.clientObject);
        this.surveyCode = SurveyService.resetSurveyCode(this.clientObject);
        this.dataLoaded = true;
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }
    },
    loadData() {
      let useW30AsDefaultClient = false;
      if (localStorage.getItem("use-w30-as-default-client") != null) {            
        useW30AsDefaultClient = localStorage.getItem("use-w30-as-default-client");
        if (useW30AsDefaultClient == "true"){
          let vm = this;
          setTimeout(function() {
            vm.$notify(AdminService.displayErrorMessage({ text: "You no longer have any active organizations to display. Contact your Research Advisor to gain access to an active organization within your company. In the interim, you can still use and analyze the W-30 companies." }));
            localStorage.removeItem("use-w30-as-default-client");
          }, 1500);    
        }
      }      
      ClientService.getAllClientsFromDatabase(this.getAllClientsCallback,useW30AsDefaultClient);
      this.clientObject = ClientService.getClient();
      this.clientId = this.clientObject.clientId;
      this.clientCode = this.clientObject.clientCode;
      this.treeValue = this.clientCode;
      this.loadSurveyData();
      this.dataLoaded = true;
      this.logoImage = this.userImage;
    },
    loadSurveyData() {
      let savedSurveyCode = SurveyService.getSurveyCode();
      if (savedSurveyCode != "" && SurveyService.contains(savedSurveyCode)) {
        this.surveyCode = savedSurveyCode;
      } else {
        this.surveyCode = SurveyService.resetSurveyCode(this.clientObject);
      }
    },
    async isAuthenticated() {
      this.authenticated = await this.$auth.isAuthenticated();
    },
    async handleLogout() {
      let email = typeof this.currentUser != "undefined" ? this.currentUser.email : "unknown";
      GoogleService.logBaseEvent("logout", "Logout Successful", email, 0, this);
      let executedLogout = oktaAuthLogout(oktaAuth);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  async created() {
    this.$log.info("Starting " + process.env.VUE_APP_TITLE);
    this.$log.info("Base URL  " + this.baseUrl);
    this.$log.info("Base Interview URL  " + process.env.VUE_APP_INTERVIEW_URL);
    if (this.isAuthenticated()) {
      this.loadData();
    }
  },
  watch: {
    currentUser: function() {
      this.loadData();
    },
    clientObject: function() {
      ClientService.saveClient(this.clientObject);
    },
    surveyCode: function() {
      if (this.surveyCode != "") {
        SurveyService.setSurveyCode(this.surveyCode);
        this.survey = SurveyService.getSurvey();
      }
    }
  },
  destroyed() {},
  computed: {
    surveyLabel: function(){
      return this.displaySurveyWidget ? "Survey" : "Survey Link";
    },
    fullUrl: function() {
      return SurveyService.getBaseInterviewUrl() + "/" + this.survey.clientId + "/s/" + this.survey.url;
    },    
    displayScrollToTopButton: function(){
      return this.scrollYAxis > 300;
    },
    defaultExpandLevel: function() {
      // IF  Admins and Power Users = 0, otherwise 4
      //return (this.isAdmin || this.isPowerUser) ? 0 : 4;
      return 0;
    },
    surveyOptions: function() {
      let options = [];
      for (let surveyIndex = 0; surveyIndex < this.clientObject.surveyCodes.length; surveyIndex++) {
        let newSurveyOption = new Object();
        newSurveyOption.id = this.clientObject.surveyCodes[surveyIndex].surveyCode;
        newSurveyOption.label = this.clientObject.surveyCodes[surveyIndex].name;
        options.push(newSurveyOption);
      }
      return options;
    },
    displaySurveyWidget: function() {
      if (!jQuery.isEmptyObject(this.clientObject.surveyCodes)) {
        return this.clientObject.surveyCodes.length > 1;
      }
      return false;
    },
    isLoggedIn: function() {
      return this.$store.state.auth.status.loggedIn;
    },
    isAdmin: function() {
      if (this.currentUser && this.currentUser.userTypeName) {
        return this.currentUser.userTypeName == "Admin";
      } else {
        return false;
      }
    },
    isAdvancedUser: function() {
      if (this.currentUser && this.currentUser.userTypeName) {
        return this.currentUser.userTypeName == "Advanced User";
      } else {
        return false;
      }
    },
    isPowerUser: function() {
      if (this.currentUser && this.currentUser.userTypeName) {
        return this.currentUser.userTypeName == "Power User";
      } else {
        return false;
      }
    },
    isInsiderUser: function() {
      if (this.currentUser && this.currentUser.userTypeName) {
        return this.currentUser.userTypeName == "Insider User";
      } else {
        return false;
      }
    },
    isExecutiveUser: function() {
      if (this.currentUser && this.currentUser.userTypeName) {
        return this.currentUser.userTypeName == "Executive User";
      } else {
        return false;
      }
    },
    isBasicUser: function() {
      if (this.currentUser && this.currentUser.userTypeName) {
        return this.currentUser.userTypeName == "Basic User";
      } else {
        return false;
      }
    },
    currentUser: function() {
      if (this.isLoggedIn) {
        return this.$store.state.auth.user;
      } else {
        return null;
      }
    },
    userImage: function() {
      if (this.clientId != 0) {
        return this.baseUrl + "/api/v1/content/get-logo-by-user-id?viewType=inline&userId=" + UserService.getUserId() + "&r=" + Math.random();
      } else {
        return "";
      }
    },
    clientName: function() {
      return this.clientObject.name;
    },
    fullName: function() {
      if (this.currentUser && this.currentUser.firstName && this.currentUser.lastName) {
        return this.currentUser.firstName + " " + this.currentUser.lastName;
      } else {
        return "";
      }
    },
    isW5OUser: function() {
      return UserService.isW5OUser(this.clientObject, this.isAdmin);
    }
  },
  props: {
    baseUrl: {
      type: String,
      default: process.env.VUE_APP_BASE_URL
    }
  }
};
window.onerror = function(message, source, lineno, colno, error) {
  var string = "";
  if (message.toLowerCase) {
    string = message.toLowerCase();
  }
  var substring = "script error";
  var resizeMessage = "resizeobserver";
  if (string.indexOf(substring) > -1) {
    //alert("Script Error: See Browser Console for Detail");
  } else if (string.indexOf(resizeMessage) > -1) {
    return false;
  } else {
    var customMessage = ["Message: " + message, "source: " + source, "Line: " + lineno, "Column: " + colno, "Error object: " + JSON.stringify(error)].join(" - ");
    ErrorService.logException(source, customMessage, "window");
  }
  return false;
};
window.alert = (function() {
  var nativeAlert = window.alert;
  return function(message) {
    //window.alert = nativeAlert;
    if (message.indexOf("DataTables warning") === 0) {
      // eslint-disable-next-line no-console
      console.warn(message);
    } else {
      nativeAlert(message);
    }
  };
})();
</script>
